<div *ngIf="paymentsDisabledMessage" class="top-message">
  {{paymentsDisabledMessage}}
</div>
